module.exports = __webpack_public_path__ + "static/img/bb.0d0bcae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bb.png
// module id = bLoF
// module chunks = 1